import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Next_logo.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center min-h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      class: "mb-5"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-bold text-xl" }, "404", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Quello che stai cercando non è qui.", -1)),
    _createVNode(_component_router_link, {
      to: {name:'Dashboard'},
      class: "text-next-orange"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Torna alla home")
      ])),
      _: 1
    })
  ]))
}